interface StatisticFooterProps {
  title: string;
  children?: JSX.Element;
}

function StatisticFooter( { title, children }: StatisticFooterProps ) {
  return (
    <div className="w-full border-t h-full py-5">
      <div className="flex flex-col items-center">
        <span className="text-gray-700 text-sm font-semibold mb-2">
          { title }
        </span>
        { children }
      </div>
    </div>
  );
}

export default StatisticFooter;
